// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"V4-z","dimensionLabel":"W4-z","styleChooserControlWrapper":"X4-z","styleChooserControl":"Y4-z","disabled":"Z4-z","giftCard":"_4-z","styleChooserText":"a5-z"};